import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { expVal } from '@confluence/feature-experiments';

import useAnalyticsByLineQuery, {
	type useAnalyticsByLineQuery$data,
	type useAnalyticsByLineQuery$variables,
} from './components/AnalyticsByLine/__generated__/useAnalyticsByLineQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { getAnalyticsBylineGateReason } from './analyticsBylineEligibility.ts';

export const preloadContentAnalyticsViewers = (
	contentId: string,
): Promise<{
	data: useAnalyticsByLineQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> => {
	const { edition, isLoggedIn, accessStatus, userId } = getPreloaderFnContext();
	const gateReason = getAnalyticsBylineGateReason({
		edition,
		isLoggedIn,
		accessStatus,
		userId,
	});
	if (gateReason && expVal('confluence_exp_vp_document', 'isEnabled', false)) {
		return Promise.resolve({ data: null, hasErrors: false });
	}

	return query<useAnalyticsByLineQuery$data, useAnalyticsByLineQuery$variables>({
		query: useAnalyticsByLineQuery,
		variables: { contentId },
	});
};
